import { css } from 'lit';

export const tableRowStyles = css`
  :host {
    background: var(--token-alias-background-normal, light-dark(#ffffff, #3d3d42));
    box-sizing: border-box;
    display: block;
  }

  :host([expandable]),
  :host([expanded]) {
    .cds-table-row-expand-icon {
      display: block;
    }
  }

  :host([expanded]) {
    border-bottom: 1px solid var(--token-component-table-row-border, light-dark(#d6d6dd, #515157));
    .row {
      border-bottom: none;
    }
  }

  :host([headerborder]) {
    .row {
      border-bottom: 1px solid
        var(--token-component-table-header-outlined-border, light-dark(#a3a3ab, #a3a3ab));
    }
  }


  :host([rowborder]){
    .row {
      border-bottom: 1px solid var(--token-component-table-row-border, light-dark(#d6d6dd, #515157));
    }
  }
  :host([rowborder][expanded]) {
    .row {
      border-bottom: none;
    }
  }

  :host([selectable]) {
    .cds-table-row-checkbox {
      display: block;
    }
  }

  :host([zebra]:nth-child(even)) {
    .row {
      background: var(--token-component-table-row-background-zebra, light-dark(#f7f7fa, #343438));
    }
  }

  :host([selected]) .row,
  :host([selected]:nth-child(even)) .row {
    background: var(--token-component-table-row-background-hover, light-dark(#edf8ff, #515157));
  }

  :host([selected]) .cds-table-row-checkbox,
  :host([selected]:nth-child(even)) .cds-table-row-checkbox {
    display: block;
  }


  :host([hoverable]:hover) .row {
    background: var(--token-alias-interaction-background-primary-hover, light-dark(#edf8ff, #47474d));
  }
  .row {
    align-items: center;
    align-self: stretch;
    background: var(--token-alias-background-normal, light-dark(#ffffff, #3d3d42));
    display: flex;
    padding: 0px var(--token-global-spacing-s12, 12px);
  }

  /* Header Row Override: when consumer sets headerbackground attr (reflected property) */
  :host([headerbackground]) .row {
    background: var(
      --cds-table-header-background,
      var(--token-alias-background-normal, light-dark(#ffffff, #3d3d42))
    );
  }

  .row.expanded {
    animation: fadeIn 0.3s;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(-50%);
    }
    100% {
      opacity: 1;
      transform: translateY(0%);
    }
  }
`;
